<template>
  <v-app id="app">
    <router-view ></router-view>
    <ConfirmModal ref="confirm"/>
  </v-app>
</template>

<script>
import ConfirmModal from '@/components/emergentesGlobales/ConfirmModal'

export default {
  name: 'App',
  components: {
    ConfirmModal
  },
  async mounted () {
    this.$root.$confirm = this.$refs.confirm.open
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;800&display=swap');

html, body {
  scrollbar-width: none;
  scrollbar-color: #0583DA transparent;
}

html::-webkit-scrollbar, body::-webkit-scrollbar {
  width: 10px;
}

html::-webkit-scrollbar-track, body::-webkit-scrollbar-track {
  background: rgba(5, 131, 218, 0.05);
  border-radius: 10px;
  margin: 4px 0;
}

html::-webkit-scrollbar-thumb, body::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #1FC1D0, #0583DA);
  border-radius: 10px;
  border: 2px solid transparent;
  background-clip: padding-box;
  transition: all 0.3s ease;
}

html::-webkit-scrollbar-thumb:hover, body::-webkit-scrollbar-thumb:hover {
  background: #0583DA;
}

html::-webkit-scrollbar-button, body::-webkit-scrollbar-button {
  display: none;
}

#app {
  overflow: hidden !important;
  & * {
        font-family: Poppins, sans-serif;
  }
}
</style>
